import { createContext } from "react"

import {
  BusinessIdentityProvider,
  Currency,
  IdentityProvider,
  IsoLocale,
  iZettleMarket,
} from "@izettle/constants"

import {
  MechantDbaData,
  OrganizationData,
  SettingsData,
  UserUserData,
} from "./user.types"

export type LocaleData = {
  language: string
  country: iZettleMarket
  currency: Currency
  isoLocale: IsoLocale
}

export type Feature = {
  name: string
  activated: boolean
  enabled: boolean
  type: string
}

export type UserData = {
  // From user endpoint
  merchantDbaData: MechantDbaData
  organization: OrganizationData
  user: UserUserData

  /** @deprecated Use `userData.user.settings` instead! */
  settings: SettingsData

  // From identity provider endpoint
  identityProvider: IdentityProvider
  identityProviderId: string
  businessIdentityProvider: BusinessIdentityProvider

  // From features endpoint
  features: Feature[]

  isPayPal: boolean
  // Computed data
  locale: LocaleData

  // TODO: Move to utility function
  isMobileApp: boolean
}

export const UserContext = createContext<UserData>(null!)
